/* SEVEN ÁNGEL – Rabattcode im Warenkorb-Einschub */
(function () {
  if (window.__saCart) return;
  window.__saCart = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function box() { return document.querySelector('cart-drawer [data-sa-discount]'); }
  function msg(text) { var b = box(); var m = b && b.querySelector('.sa-discount__msg'); if (m) m.textContent = text || ''; }
  function appliedCodes(b) {
    return [].map.call((b || document).querySelectorAll('[data-sa-code]'), function (el) { return el.getAttribute('data-sa-code'); });
  }

  function setCodes(codes) {
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (r) { return r.json(); });
  }

  function rerender() {
    return fetch(window.location.pathname + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.drawer__inner');
        var current = document.querySelector('cart-drawer .drawer__inner');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      });
  }

  function busy(b, on) {
    var btn = b && b.querySelector('.sa-discount__btn');
    if (btn) btn.disabled = on;
  }

  function apply(b) {
    var input = b.querySelector('.sa-discount__input');
    var code = (input.value || '').trim();
    if (!code) return;
    var error = b.getAttribute('data-error') || 'Code ungültig.';
    var lower = code.toLowerCase();
    var codes = appliedCodes(b).filter(function (c) { return c.toLowerCase() !== lower; });
    codes.push(code);
    busy(b, true);
    msg('');
    setCodes(codes)
      .then(function (cart) {
        var list = Array.isArray(cart.discount_codes) ? cart.discount_codes : null;
        if (!list) throw new Error('no-discount-support');
        var hit = list.filter(function (d) { return String(d.code).toLowerCase() === lower; })[0];
        if (hit && hit.applicable) return rerender();
        var keep = list.filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
        return setCodes(keep).then(rerender).then(function () { msg(error); });
      })
      .catch(function () { busy(box(), false); msg(error); });
  }

  function remove(code) {
    var b = box();
    var lower = String(code).toLowerCase();
    var codes = appliedCodes(b).filter(function (c) { return c.toLowerCase() !== lower; });
    busy(b, true);
    setCodes(codes).then(rerender).catch(function () { busy(box(), false); });
  }

  document.addEventListener('click', function (e) {
    var lo = e.target.closest && e.target.closest('[data-sa-label-open]');
    if (lo) {
      e.preventDefault();
      var dlg = lo.parentElement.querySelector('[data-sa-label-dialog]');
      if (dlg && dlg.showModal) dlg.showModal(); else if (dlg) dlg.setAttribute('open', '');
      return;
    }
    var lc = e.target.closest && e.target.closest('[data-sa-label-close]');
    if (lc) { e.preventDefault(); lc.closest('dialog').close(); return; }
    if (e.target.matches && e.target.matches('[data-sa-label-dialog]')) { e.target.close(); return; }
    var btn = e.target.closest && e.target.closest('.sa-discount__btn');
    if (btn) { e.preventDefault(); apply(btn.closest('[data-sa-discount]')); return; }
    var rm = e.target.closest && e.target.closest('[data-sa-remove-code]');
    if (rm) { e.preventDefault(); remove(rm.getAttribute('data-sa-remove-code')); }
  });

  var escFromDialog = false;
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') escFromDialog = !!document.querySelector('[data-sa-label-dialog][open]');
  }, true);
  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape' && escFromDialog) { escFromDialog = false; e.stopPropagation(); }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest && e.target.closest('.sa-discount__input');
    if (!input) return;
    e.preventDefault();
    apply(input.closest('[data-sa-discount]'));
  });
})();
